import {PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const";
import React from "react";
import ProjectSession from "../../../../model2/project/project-session";
import ProjectColorSelector from "../../../../gd-components/selector/project-color-selector/project-color-selector";
import {changeProjectColor} from "../actions/change-project-color";

export default function moreProject_SelectColor(project: ProjectSession, options:Option[], disabled:boolean) {

    const onChange = (color: number)=> {
        changeProjectColor(project, color)
    }

    options.push({
        type            : PopoverMenuItemType.CUSTOM_POPOVER,
        label           : "Change color",
        icon            : "i5-color",
        menuComponent   : (params:any)=>{
            return <ProjectColorSelector project        = {params.menuParams.project}
                                         onChange       = {onChange}
                                         hidePopover    = {params.menuParams.hidePopover} />
        },
        disabled        : disabled,
    })
}
